import { DesignedIcon, Rule } from "@with-nx/simple-ui/atoms";
import { Box } from "simple-effing-primitive-layout";
import Image from "next/image";

import { Col, Row } from "antd";
import { useEffect, useRef, useState } from "react";

export const BackdropsLibraries = ({ mobile }) => {
  const libraries = [
    {
      title: "Shows",
      description: "Browse our library by show title",
      id: "shows",
      image: "preview_shows",
      video: "/assets/digital-backdrops/shows_library_backdrop.mp4",
    },
    {
      title: "Themes",
      description: "Browse our library by backdrop theme",
      id: "themes",
      image: "preview_themes",
      video: "/assets/digital-backdrops/themes_library_backdrop.mp4",
    },
    {
      title: "Events",
      description: "Find the perfect backdrop for your event",
      id: "events",
      image: "preview_events",
      video: "/assets/digital-backdrops/events_library_backdrop.mp4",
    },
    {
      title: "Full Library",
      description: "Explore our full library of backdrops",
      id: "library",
      image: "preview_library",
      video: "/assets/digital-backdrops/full_library_backdrop.png",
    },
  ];

  return (
    <div className="container">
      <Box parse="mb:100">
        <Row gutter={[50, 50]}>
          {libraries.map(({ id, title, description, image, video }) => {
            const [hover, _hover] = useState(false);
            const [opacity, _opacity] = useState(1);

            const ref = useRef<HTMLVideoElement>(null);

            useEffect(() => {
              if (ref.current) {
                if (hover) {
                  if (ref.current) {
                    ref.current.onloadeddata = () => {
                      if (ref.current) {
                        try {
                          ref.current.currentTime =
                            ref.current.duration >= 10 ? 5 : 0;
                          ref.current.play?.();
                        } catch (error) {
                          console.error(error);
                        }
                        _opacity(0.2);
                      }
                    };

                    ref.current.src = video;
                    ref.current.load();
                    _opacity(1);
                  }
                } else {
                  _opacity(1);
                  ref.current.pause();
                  ref.current.src = "";
                  ref.current.currentTime = ref.current.duration >= 10 ? 5 : 0;
                }
              }
            }, [hover]);

            return (
              <Col xs={24} lg={12} key={`library-${title}`}>
                <div
                  onMouseEnter={() => _hover(true)}
                  onMouseLeave={() => _hover(false)}
                >
                  <Box
                    parse="d:block p:relative w:100% h:341 br:10 oa:hidden"
                    background="linear-gradient(97.56deg, #1E242D 0%, #1E242D 19.55%, #171B20 59.51%)"
                    border="1px solid var(--grey-20)"
                    element="a"
                    native={{
                      href: `/digital-backdrops/${id}`,
                    }}
                  >
                    <Box parse="p:absolute w:100% h:100% t:0 l:0 z:0">
                      <video
                        id={video}
                        src={video}
                        poster={`/assets/digital-backdrops/${image}.png`}
                        muted
                        loop
                        ref={ref}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          opacity,
                        }}
                        preload="none"
                      />
                    </Box>

                    <Box
                      parse={`p:relative d:flex fd:column a:center pa:55 pl:88 pr:88 z:2 ${
                        mobile ? "j:center" : ""
                      }`}
                    >
                      <Image
                        src={`/assets/digital-backdrops/${id}.svg`}
                        width={80}
                        height={80}
                        loading="lazy"
                      />

                      <Rule
                        parse={`!${mobile ? "_h2" : "_h1"} d:block ta:center`}
                      >
                        {title}
                      </Rule>
                      <Rule
                        parse={`!_h3 d:block ta:center mb:14 mt:5 c:var(--grey-20)`}
                      >
                        {description}
                      </Rule>
                      <DesignedIcon
                        name="circle_arrow_right"
                        size={32}
                        color="var(--grey-20)"
                      />
                    </Box>
                  </Box>
                </div>
              </Col>
            );
          })}
        </Row>
      </Box>
    </div>
  );
};
